if ($(window).width() < 750) {
  $('.footer-block.footer-block-link_list .footer-block__heading').click(function () {
    $(this).parent().toggleClass('active');
    $(this).parent().find('.footer-block__details-content').slideToggle();
  });
}

$('.grid-setting-body .grid-column').click(function () {
  $('.grid-setting-body .grid-column').removeClass('active');
  $(this).addClass('active');

  $('body').find('#product-grid').addClass('');
});

$(document).on('click', '.grid-setting-body .grid-column-2', function () {
  if ($(window).width() > 750) {
    $('body').find('#product-grid').removeClass('grid--4-col-desktop').addClass('grid--3-col-desktop');
  }
});

$(document).on('click', '.grid-setting-body .grid-column-3', function () {
  if ($(window).width() > 750) {
    $('body').find('#product-grid').removeClass('grid--3-col-desktop').addClass('grid--4-col-desktop');
  }
});

$(document).on('click', '.grid-setting-body .grid-column-2', function () {
  if ($(window).width() < 750) {
    $('body').find('#product-grid').removeClass('grid--2-col-tablet-down').addClass('grid--1-col-tablet-down');
  }
});

$(document).on('click', '.grid-setting-body .grid-column-3', function () {
  if ($(window).width() < 750) {
    $('body').find('#product-grid').removeClass('grid--1col-tablet-down').addClass('grid--2-col-tablet-down');
  }
});

$(document).on('click', '.faq---wraper-question', function () {
  $(this).parent().toggleClass('active');
  $(this).parent().find('.faq---wraper-answer').slideToggle();
});

$(document).ready(function () {
  $('details.mega-menu').each(function () {
    const $detail = $(this);
    const $summary = $detail.find('summary.header__menu-item');
    const $content = $detail.find('.mega-menu__content');

    // Hover in
    $summary.add($content).on('mouseenter', function () {
      $detail.attr('open', true);
      $detail.closest('.template-index sticky-header').removeClass('header-wrapper--transparent').addClass('open-mega');
    });

    // Hover out
    $summary.add($content).on('mouseleave', function (e) {
      if (!$(e.relatedTarget).closest($detail).length) {
        $detail.removeAttr('open');
        $detail.closest('.template-index sticky-header').removeClass('open-mega').addClass('header-wrapper--transparent');
      }
    });
  });
});

$(document).ready(function () {
  $('.menu_wrapper----col span').click(function () {
    $(this).parents('.custom_wrapper_item').toggleClass('active');
    $(this).parents('.custom_wrapper_item').find('.custom_wrapper_item_ul').slideToggle();
  });
});

// MAIN PRODUCT STICKY BAR
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-bar');
  const addToCartSection =
    document.querySelector('.product__info-wrapper .add___to_cart__btn_wrapper') || document.querySelector('.product__info-wrapper .product-form__buttons') || document.querySelector('.product__info-wrapper product-form') || document.querySelector(".product__info-wrapper form[action*='/cart/add']");
  const footer = document.querySelector('footer.footer');
  const header = document.querySelector('header');

  if (stickyBar && (addToCartSection || footer)) {
    const headerHeight = header ? header.offsetHeight : 0;

    function isInViewport(element) {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > headerHeight;
    }

    function hasScrolledPast(element) {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom <= headerHeight;
    }

    function checkStickyVisibility() {
      const footerVisible = isInViewport(footer);
      const passedAddToCart = hasScrolledPast(addToCartSection);

      // Show ONLY after the main buy button has been scrolled past.
      // This prevents the sticky bar from showing on initial load when the buy button is below the fold.
      if (!footerVisible && passedAddToCart) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    }

    checkStickyVisibility();
    window.addEventListener('scroll', checkStickyVisibility, { passive: true });
    window.addEventListener('resize', checkStickyVisibility);
  }
});
